import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';


export interface FileUploadProps extends React.HTMLProps<HTMLElement> {
  promptText: string;
  // the file param would be null if the user hit cancel in the select file dialog
  onFileSelect: (file: File) => void;
  tbTestId: string;
  disabled?: boolean;
  loading?: boolean;
  file?: File;
  maxFilenameWidth?: number;
}

export class FileUpload extends React.Component<FileUploadProps, {}> {
  private refId: React.RefObject<any>;
  private boundHandleChange: () => void;
  private boundHandleButtonClick: () => void;

  public constructor(props: FileUploadProps) {
    super(props);
    this.refId = React.createRef();
    this.boundHandleChange = this.handleChange.bind(this);
    this.boundHandleButtonClick = this.handleButtonClick.bind(this);
  }

  private handleChange(formEvent: React.FormEvent<EventTarget>): void {
    const file = (formEvent.target as HTMLInputElement).files[0];
    this.props.onFileSelect(file);
  }

  /**
   * Handles the click event on the visible button by sending a click event to the hidden file input.
   */
  private handleButtonClick(): void {
    const element = this.refId.current as HTMLElement;
    element.click();
  }

  public render(): JSX.Element {
    return (
        <><ButtonWidget
            handleClick={this.boundHandleButtonClick}
            testId={this.props.tbTestId}
            buttonType={ButtonType.Primary}
            disabled={this.props.disabled}>
            {this.props.promptText}
        </ButtonWidget>
            <input
                type='file'
                ref={this.refId}
                data-tb-test-id={'FileInput-' + this.props.tbTestId}
                onChange={this.boundHandleChange}
                style={{
                    display: 'none'
            }} /></>
    );
  }
}
